import { useState } from "react";
import { getCostCenterValidationReports } from "../api/reportsClient";
import { FlagProjectsReportSummary } from "../api/models/ReportModels";

export const useReports = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [reports, setReports] = useState<FlagProjectsReportSummary[]>([]);

    const fetchReports = async () => {
        setIsLoading(true);
        try {
            const data = await getCostCenterValidationReports();
            setReports(data);
        } catch (error) {
            console.error("Error fetching reports:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return {
        isLoading,
        reports,
        fetchReports
    };
};
